import { createFeature, createReducer, on } from '@ngrx/store'

import { RoleState } from './role-permission.state'
import {
  blockRole,
  blockRoleSuccess,
  createAssignedTo,
  createAssignedToFailure,
  createAssignedToSuccess,
  createRole,
  createRoleFailure,
  createRoleSuccess,
  deleteAssignedTo,
  deleteAssignedToFailure,
  deleteAssignedToSuccess,
  // deleteRole,
  // deleteRoleFailure,
  // deleteRoleSuccess,
  loadAssignedTo,
  loadAssignedToFailure,
  loadAssignedToSuccess,
  loadRoleByIdFailure,
  loadRoleByIdSuccess,
  loadRoles,
  loadRolesFailure,
  loadRolesSuccess,
  resetRoleState,
  updateRole,
  updateRoleFailure,
  updateRoleSuccess,
  upsertValidUpto,
  upsertValidUptoFailure,
  upsertValidUptoSuccess
} from './role-permission.actions'

export const initialState: RoleState = {
  totalCount: 0,
  roles: [],
  assignedTo: null,
  loading: false,
  error: null,
  role: null
}

// Create the Role reducer
export const roleReducer = createReducer(
  initialState,
  on(loadRoles, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadRolesSuccess, (state, { totalCount, roles }) => ({
    ...state,
    totalCount,
    roles,
    loading: false,
    error: null
  })),
  on(loadRolesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createRole, state => ({ ...state, loading: true })),
  on(createRoleSuccess, (state, { role }) => ({
    ...state,
    roles: [...state.roles, role],
    loading: false
  })),
  on(createRoleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateRole, state => ({ ...state, loading: true })),
  on(updateRoleSuccess, (state, { role }) => ({
    ...state,
    role,
    loading: false
  })),
  on(updateRoleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(blockRole, (state, { id }) => ({
    ...state,
    roles: state.roles.map(role => (String(role.id) === id ? { ...role, disabled: true } : role))
  })),
  on(blockRoleSuccess, (state, { role }) => {
    // Update the business state to reflect that it is blocked
    const updatedState = {
      ...state,
      roles: state.roles.map(
        b => {
          if (b.id === role.id) {
            // console.log('updated business', { ...b, ...Role })
            return { ...b, ...role }
          } else return b
        } // Update the business object
      ),
      error: null
    }
    return updatedState
  }),
  // on(deleteRole, (state, { id }) => ({
  //   ...state,
  //   roles: state.roles.map(role => (String(role.id) === id ? { ...role, disabled: true } : role))
  // })),
  // on(deleteRoleSuccess, (state, { id }) => {
  //   // Update the business state to reflect that it is successfully deleted
  //   const updatedState = {
  //     ...state,
  //     roles: state.roles.filter(b => b.id !== id), // Remove the business from the list
  //     error: null
  //   }
  //   return updatedState
  // }),
  // on(deleteRoleFailure, (state, { error }) => ({
  //   ...state,
  //   error
  // })),
  on(loadAssignedTo, upsertValidUpto, deleteAssignedTo, createAssignedTo, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    loadAssignedToSuccess,
    upsertValidUptoSuccess,
    deleteAssignedToSuccess,
    createAssignedToSuccess,
    (state, { assignedTo }) => ({
      ...state,
      loading: false,
      error: null,
      assignedTo
    })
  ),
  on(
    loadAssignedToFailure,
    upsertValidUptoFailure,
    deleteAssignedToFailure,
    createAssignedToFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error
    })
  ),
  on(loadRoleByIdSuccess, (state, { role }) => {
    // console.log('role', role)
    return {
      ...state,
      role: role,
      error: null
    }
  }),
  on(loadRoleByIdFailure, (state, { error }) => ({
    ...state,
    role: null,
    error
  })),
  on(resetRoleState, () => initialState)
)

// Create the feature for the Role state
export const roleFeature = createFeature({
  name: 'Role', // Feature name
  reducer: roleReducer
})
export type { RoleState }
// Export the feature's selectors
export const {
  name,
  reducer,
  selectRoles,
  selectAssignedTo,
  selectLoading,
  selectError,
  selectRole,
  selectTotalCount
} = roleFeature
